// extracted by mini-css-extract-plugin
export default {"tag":"ExplicitTag_tag__DDQSJ","small":"ExplicitTag_small__GDyeS","xsmall":"ExplicitTag_xsmall__gINeu","default":"ExplicitTag_default__oCxhR"};